<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择收款"
      class="customer-edit"
      width="95%"
      top="5vh">
    <vm-table
        ref="vmTable"
        height="60vh"
        :filter.sync="filter"
        module="basic"
        url="sd/receiptRecord">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="记账日期">
            <div class="block">
              <el-date-picker
                  v-model="filter.accountingDateStart"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  style="width: 190px"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.accountingDateEnd"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width: 190px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
          <vm-search label="凭证号">
            <el-input v-model.trim="filter.financialDocNo" clearable/>
          </vm-search>
          <vm-search label="客户">
            <el-input v-model.trim="filter.customerName" clearable/>
          </vm-search>
        </div>
        <vm-search label="创建日期">
          <div class="block">
            <el-date-picker
                v-model="filter.createDateStart"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.createDateEnd"
                value-format="yyyy-MM-dd 23:59:59"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
      </template>
      <el-table-column align="center" prop="financialDocNo" label="凭证号"/>
      <el-table-column align="center" prop="accountingDate" label="记账日期">
        <template slot-scope="scope">
          <span>{{scope.row.accountingDate.slice(0,10)}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="createDate" label="创建日期">
        <template slot-scope="scope">
          <span>{{scope.row.createDate.slice(0,10)}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="rowIndex" label="行号"/>
      <el-table-column align="center" prop="customerName" label="客户"/>
      <el-table-column align="center" prop="amount" label="金额"/>
      <el-table-column label="操作" align="center" width="80px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";


  export default {
    name:"",
    components: {VmTable,VmSearch},
    data() {
      return {
        constant,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList: "",
        fiType:"",
        filter: {
          financialDocNo: "",
          customerName: "",
          accountingDateStart: "",
          accountingDateEnd: "",
          createDateStart: "",
          createDateEnd: "",
        },
      };
    },
    methods: {
      open(fiType) {
        this.fiType = fiType;
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        console.log(row);
        this.$emit("select", row,this.fiType);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
